import { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../Base.constants';
import LoanWaiverContent, { LoanWaiverContentProps } from '../LoanWaiverContent/LoanWaiverContent';
import styles from './LoanWaiverLimitView.module.scss';

const cx = classNames.bind(styles);

type LoanWaiverLimitViewProps = Omit<LoanWaiverContentProps, 'onCancel'>;

const LoanWaiverLimitView = ({ isMyContent, ...props }: LoanWaiverLimitViewProps): ReactElement => {
  const navigate = useNavigate();

  return (
    <div className={cx('body', { 'my-content': isMyContent })}>
      <LoanWaiverContent {...props} onCancel={() => navigate(ROUTES.feed)} isInArticlePage isMyContent={isMyContent} />
    </div>
  );
};

export default LoanWaiverLimitView;
